module.exports = __webpack_public_path__ + "img/manual-coin.19666d8.webp";